module.exports = __webpack_public_path__ + "img/icon-server-2.470c60c7.png";